import { useModal } from '@aloft/toolkit-sui';

import { SimilarityScoreWeightingModalInternal } from '../internal/SimilarityScoreWeightingModalInternal.tsx';

export const useSimilarityScoreWeightingModal = () => {
  const { Modal, openModal, isModalOpen, closeModal } = useModal();

  const WeightingModal = isModalOpen ? (
    <SimilarityScoreWeightingModalInternal
      Modal={Modal}
      closeModal={closeModal}
      isModalOpen={isModalOpen}
    />
  ) : null;

  return {
    SimilarityScoreWeightingModal: WeightingModal,
    openSimilarityScoreWeightingModal: openModal,
  };
};
